import { getPieRadius } from '../../utils/chart';
import { backgroundColor, textColor } from '../../theme/common/color'; // 进度条环形的外半径与环形的内半径的比例

var progressRingRatio = 1.3;
var defaultProgressMax = 100;
export default function (chart, _ref) {
  var progressMaxValue = _ref.progressMaxValue,
      labelLine = _ref.labelLine;
  var radius = getPieRadius(chart.radius);
  var _chart$data = chart.data,
      data = _chart$data[0];
  chart.silent = true; // set inside radius

  chart.radius[0] = radius.outside / progressRingRatio; // 进度条样式的灰色区域

  chart.data.push({
    value: (progressMaxValue || defaultProgressMax) - data.value,
    name: 'pagoda-ring-progrees-gray-pie',
    itemStyle: {
      normal: {
        color: backgroundColor.normal
      },
      emphasis: {
        color: backgroundColor.normal
      }
    },
    label: {
      normal: {
        show: false
      }
    }
  });

  if (!labelLine) {
    chart.label.normal.rich = {
      name: {
        fontSize: 10,
        padding: 8,
        color: textColor.grayDark
      },
      value: {
        fontSize: 17,
        color: textColor.normal
      }
    };
  }
}